<template>
    <div>
    <p> {{ $t('commute.title.car-monthly_maintenance.info', {cost: convert('formatMoney', cost_per_1000_dist_units), unit_distance: settings('getDistanceUnit') } ) }} </p>
    <div class="table" v-if="maintenance_items.length > 0"  >
        <div class="body">
            <div class="tablerow">
                
                <div class="cell">
                    {{ $t('item') }}
                </div>
                
                <div class="cell">
                {{ $t('cost') }}
                </div>
                <div class="cell">
                {{ $t('frequency') }}
                
                </div>
            </div>
            
            <div class="tablerow" v-for="item in maintenance_items" >
                <div class="cell">
                {{ item.label }}  
                </div>
                <div class="cell">
                
                {{ convert('formatMoney', '') }}
                
                    <ConvertedNumber
                    classes="money" 
                    v-on:input="set_cost(item.name, 'cost', $event)"
                    :default_value="costs[item.name]['cost']"
                    :min=0
                    :step=10
                    :max="costs[item.name]['default_cost']*10"
                    />
                        
                </div>
                <div class="cell">
                
                {{ $t('every') }}
                
                     <ConvertedNumber
                    v-on:input="set_cost(item.name, 'freq', $event)"  
                    :default_value="parseFloat(costs[item.name]['freq'])" 
                    :min="item.min"
                    :max="item.max"
                    :step=1000
                    :round_to_nearest=1000
                    classes="bigmoney"
                    :display_conversion="display_function('distance')"
                    :store_conversion="store_function('distance')"
                    />
                    {{ convert('formatDistance')  }}
                 </div>
            </div>
        </div>
         
    </div>
    </div>   
</template>

<script>
    import ConvertedNumber from './ConvertedNumber.vue'
    import Persistent from '../mixins/Persistent.js'

    import settings from '../settings.js'
    import conversions from '../conversions.js'

    export default {
        mixins: [Persistent],
        components: {
            ConvertedNumber
        },
        data: function(){
            return {
                costs : {}               
            }
        },
        props: {
            vehicle: ""
        },
        created() {
            this.init()

        },
        watch : {
            vehicle : function(){
                this.init()
            }
        },
        computed : {
            unit_distance : function(){
                return settings.getDistanceUnit();
            },
            maintenance_items: function(){
                let items = [
                    {
                        name: "bike_inspection",
                        label: this.$t('vehicle.maintenance.inspection'),
                        default_cost: 50,
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_km: 3000,
                        min: 1000,
                        max: 15000
                    },{
                        name: "tires",
                        label: this.$t('vehicle.maintenance.tires'),
                        vehicles: ['car', 'motorcycle'],
                        default_cost: 200,
                        default_km: 50000,
                        min: 10000,
                        max: 100000
                    },{
                        name: "bike_tires",
                        label: this.$t('vehicle.maintenance.tires'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 60,
                        default_km: 5000,
                        min: 1000,
                        max: 10000
                    },{
                        name: "bike_innertubes",
                        label: this.$t('vehicle.maintenance.bike-innertubes'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 10,
                        default_km: 5000,
                        min: 1000,
                        max: 10000
                    },{
                        name: "bike_battery",
                        label: this.$t('vehicle.maintenance.battery'),
                        vehicles: ['e-bicycle'],
                        default_cost: 400,
                        default_km: 50000,
                        min: 20000,
                        max: 200000
                    },{
                        name: "bike_brakes",
                        label: this.$t('vehicle.maintenance.brakes'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 20,
                        default_km: 5000,
                        min: 3000,
                        max: 10000
                    },{
                        name: "brakes",
                        label: this.$t('vehicle.maintenance.brakes'),
                        vehicles: ['car', 'motorcycle'],
                        default_cost: 200,
                        default_km: 50000,
                        min: 30000,
                        max: 100000
                    },{
                        name: "oil",
                        label: this.$t('vehicle.maintenance.oil'),
                        default_cost: 50,
                        vehicles: ['car', 'motorcycle'],
                        default_km: 8000,
                        min: 2000,
                        max: 20000

                    },{
                        name: "ac",
                        label: this.$t('vehicle.maintenance.ac'),
                        vehicles: ['car'],
                        default_cost: 50,
                        default_km: 10000,
                        min: 5000,
                        max: 100000
                    },{
                        name: "inspection",
                        label: this.$t('vehicle.maintenance.inspection'),
                        default_cost: 50,
                        vehicles: ['car', 'motorcycle'],
                        default_km: 8000,
                        min: 1000,
                        max: 15000
                    },{
                        name: "wipers",
                        label: this.$t('vehicle.maintenance.wipers'),
                        vehicles: ['car'],
                        default_cost: 20,
                        default_km: 8000,
                        min: 5000,
                        max: 50000
                    },{
                        name: "filters",
                        label: this.$t('vehicle.maintenance.filters'),
                        vehicles: ['car'],
                        default_cost: 40,
                        default_km: 8000,
                        min: 5000,
                        max: 80000
                    },{
                        name: "chain",
                        label: this.$t('vehicle.maintenance.chain'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 30,
                        default_km: 3000,
                        min: 2000,
                        max: 50000
                    },{
                        name: "chain_lube",
                        label: this.$t('vehicle.maintenance.chain-lube'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 10,
                        default_km: 8000,
                        min: 5000,
                        max: 80000
                    },{
                        name: "helmet_accessories",
                        label: this.$t('vehicle.maintenance.helmet-accessories'),
                        vehicles: ['bicycle', 'e-bicycle'],
                        default_cost: 30,
                        default_km: 4000,
                        min: 1000,
                        max: 500000
                    }
                ]
                
                let out = []
                for(let i in items){
                    if(items[i].vehicles.includes(this.vehicle)){
                        out.push(items[i])
                    }
                }
                return out
            
            },
            cost_per_1000_dist_units : function(){
                let dist_km = this.display_function('distance')(1000) // 1000 display units in km
                
                let total = 0
                for(let k in this.costs){
                    let count = dist_km / this.costs[k].freq
                    let cost = this.costs[k].cost
                    total = total + (cost * count)
                    
                }
                //console.log("total = "+total)
        
                return total
            
            
                
            }
            
        },
        methods: {
            init: function(){
                let costs = {}
                //console.log("vehicle maintenance costs init() vehicle="+this.vehicle)
                //console.log("vehicle maintenance costs init() init_data="+init_data)
                for (let k in this.maintenance_items){
                    //console.log("vehicle maintenance costs init() typeof(this.init_data[this.maintenance_items[k].name])="+typeof(this.init_data[this.maintenance_items[k].name]))
                    //console.log("vehicle maintenance costs init() typeof(this.costs[this.maintenance_items[k].name])="+typeof(this.costs[this.maintenance_items[k].name]))

                    
                    // default value
                    if(typeof(costs[this.maintenance_items[k].name]) == 'undefined'){
                        costs[this.maintenance_items[k].name] = {}
                    }

                    if(costs[this.maintenance_items[k].name]['cost'] == null){
                        //console.log("default_cost this.maintenance_items[k].name="+this.maintenance_items[k].name)
                        costs[this.maintenance_items[k].name]['cost'] = this.maintenance_items[k].default_cost
                    }
                    if(costs[this.maintenance_items[k].name]['freq'] == null){
                        costs[this.maintenance_items[k].name]['freq'] = this.maintenance_items[k].default_km
                    }
                    //console.log("typeof(this.init_data[this.maintenance_items[k].name]) = "+typeof(this.init_data[this.maintenance_items[k].name]))
                    
                    if(typeof(this.init_data[this.maintenance_items[k].name]) == 'object'){
                        costs[this.maintenance_items[k].name] = this.init_data[this.maintenance_items[k].name]
                    }
                        
                    if(typeof(this.costs[this.maintenance_items[k].name]) == 'object'){
                        costs[this.maintenance_items[k].name] = this.costs[this.maintenance_items[k].name]
                    }
                    
                }
                this.costs = costs
                this.$emit('input', JSON.parse(JSON.stringify(this.costs)))

            },
            set_cost : function(which,key, val){
                this.costs[which][key] = val
                this.$emit('input', JSON.parse(JSON.stringify(this.costs)))
            },
            display_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions['km2'+unit];
                    break;
    
                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }
                        return conversions['l2'+unit];
                }
            },
            store_function: function(t){
                let unit;
                switch(t) {
                    case 'distance':
                        unit = settings.getDistanceUnit();
                        if(unit == 'km'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2km']
                    break;
                    case 'volume':
                        unit = settings.getVolumeUnit();
                        if(unit == 'l'){
                            return function(d){return d}
                        }
                        return conversions[unit+'2l']
                }
            },
            convert : function(fn, ...args){
                return conversions[fn](...args);
            },
            settings : function(fn, ...args){
                return settings[fn](...args);
            },
        }
    }
    

</script>

<style>

</style>